import { useQuery } from "react-query";

import { useAuth } from "../sdk/hooks";
import { carts } from "../sdk/utils/api";

export interface IGetAllCartsParams {
    limit: number;
    cursor: string | null;
    direction: string;
    search?: string;
}

export const useGetAllCarts = (
    queryKey: string | string[],
    parameters: IGetAllCartsParams,
) => {
    const auth = useAuth();
    return useQuery(queryKey, async () => {
        if (!auth.token) {
            throw new Error(
                "Cannot fetch carts without authorization token.",
            );
        }

        return await carts.fetchAllCarts({
            ...parameters,
            token: auth.token,
        });
    });
};